import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useAppDimensions } from '../shell/hooks/useAppDimensions';
import { isMobile } from '../shell/utils/platformCheck';
import { useAppSelector } from '../store/hooks';
import { selectAdvance } from '../store/slices/AdvanceSlice';
import { selectGameObject } from '../store/slices/gameObjectSlice';
import { GameNames } from '../store/slices/GameTypes';
import { selectMenu } from '../store/slices/menuSlice';
import { store } from '../store/store';
import { AndroidLayout } from './AndroidLayout';
import { EndingScreen } from './EndingScreen';
import { Insta } from './insta/Insta';
import { MainMenu } from './menu/MainMenu';
import { MenuOptions } from './menu/SideBar';
import { Phone } from './phoneUI/Phone2';
import { StarterScreen } from './StarterScreen';
import TProgress from './Tadvance';
import { TImageManager } from './TImageManager';
import TQuestion from './TQuestion';
import TTalkContainer from './TTalkContainer';
import TUI from './TUI';
import { ClickableMap } from './TClickableMap/TClickableMap';

interface GameWrapperProps {

}

export const GameWrapper: React.FC<GameWrapperProps> = ({ }) => {
    const menu = useAppSelector(selectMenu);
    const { keyPressed } = useAppSelector(selectAdvance);
    const game = useAppSelector(selectGameObject);
    const { vh, vw } = useAppDimensions();


    const styles = StyleSheet.create({
        mainWrapper: {
            width: "100%",
            height: "100%",
            position: "absolute",

        },
        container: {
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
        },
        aspectRatioWrapper: {
            backgroundColor: "black",
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: isMobile() ? "100%" : vh(177.78), /* 16/9 = 1.778 */
            maxHeight: isMobile() ? "100%" : vw(56.25), /* 16/9 = 1.778 */


        }
    });
    return (
        <View style={styles.mainWrapper}>
            <View style={styles.container}>
                <View style={styles.aspectRatioWrapper}>

                    {process.env.NODE_ENV === "development" ?
                        <>
                            <Text onPress={(e) => {
                                if (!isMobile()) {
                                    navigator.clipboard.writeText((e.currentTarget as any)?.innerText.split('CurrentScene: ')[1]);
                                }
                            }} selectable={true} style={{ color: "white", alignSelf: "center", paddingTop: 10, zIndex: 10, position: "absolute" }}>{`CurrentScene: ${game.present.currentScene}`}</Text>
                            {/* <Text style={{ color: "white", alignSelf: "center", padding: 10, top: 15, zIndex: 10, position: "absolute" }}>{game.present.image.url}</Text>
                            {game.present.image.partialsToDisplay?.map((i, index) => {
                                return <Text key={i.key} style={{ color: "white", alignSelf: "center", padding: 10, top: 15 + ((index + 1) * 15), zIndex: 10, position: "absolute" }}>{i.url}</Text>;

                            })} */}
                        </>
                        : <></>}
                    <TProgress>
                        {menu.loading ? <></> : <TImageManager>
                            {keyPressed !== "KeyH" ?
                                <>
                                    <TTalkContainer ></TTalkContainer>
                                    <TQuestion></TQuestion>
                                    <TUI></TUI>
                                </>
                                : <></>}
                        </TImageManager>}

                        <ClickableMap></ClickableMap>
                    </TProgress>
                    <Phone></Phone>
                    <Insta></Insta>
                    <MainMenu></MainMenu>
                    {menu.showEnding ? <EndingScreen></EndingScreen> : <></>}
                    {menu.showStarterScreen && process.env.NODE_ENV !== "development" ? <StarterScreen></StarterScreen> : <></>}

                    {/* <StarterScreen></StarterScreen> */}
                    {isMobile() && !menu.display ? <AndroidLayout></AndroidLayout> : <></>}

                </View>
            </View >
        </View>
    );
};